import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "HelpBotWidget" */ './HelpBotWidget'),
  modules: ['./HelpBotWidget'],
  loading: () => <div />
});

export default LoadableWidget;
